export const P1 = "P1";
export const P2 = "P2";
export const P3 = "P3";
export const P4 = "P4";
export const PX = "PX";
